/**
 *  公共对象
 *
 *  用于储存跨服务/组件的全局属性
 *
 **/
const Public = {
  //是否企业微信
  isWeWork: false,

  // 是否钉钉
  isDingTalk: false,

  //未登录时，缓存url中queryParams
  queryParams: {},

  //当前公司, 为避免循环引用，不放在UserService中
  companyCode: '',

  isLogin: false,

  //当前语言
  lang: 'zh-Hans',

  //是否dev环境
  isDev: window.location.hostname !== 'console.xiekeyun.com',

  //浏览器语言。中文浏览器会自动放大fontSize < 12px的字体。'zh-CN'|'en'
  browserLang: window.navigator.language,

  //浏览器时间与服务器时间之间误差
  deltaServerTime: 0,

  //获取当前服务器时间
  getServerTime() {
    return Date.now() + this.deltaServerTime;
  }
};

export default Public;
